import { get, merge } from "lodash-es"
import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static targets = ['element']
  static values = {
    url: String,
    texts: Array,
    selected: Array,
    addable: Boolean,
    settings: Object,
  }

  connect() {
    this.elementTarget.classList.remove('invisible')

    const format = this.formatOptions(this.textsValue, this.selectedValue)

    const selectOptions = { select: this.elementTarget }

    selectOptions.events ||= {}
    if (this.urlValue) {
      selectOptions.events.search = (text, _currentData) =>
        new Promise((resolve, reject) => {
          if (text.length === 0) return reject(false)

          this.fetchData(text)
            .then(json => resolve(json.map(format)))
            .catch(e => e === 403 ? reject('Más de 500 resultados') : reject('Error'))
        })
    }
    if (this.addableValue) {
      selectOptions.events.addable = (value) => value.trim()
    }

    this.select = this.buildSelect(selectOptions)

    // selectedValue must be already present in the list of options
    if (this.selectedValue.length > 0) {
      this.select.set(this.selectedValue)
    }
  }

  disconnect() {
    this.select.destroy()
  }

  fetchData(text) {
    return fetch(`${this.urlValue}${encodeURIComponent(text)}${encodeURIComponent('%')}`)
      .then(r => r.status === 403 ? Promise.reject(403) : r.json())
  }


  formatOptions(propertyPaths, selected) {
    return option => ({
      text: propertyPaths.map(v => get(option, v)).join(' '),
      value: option.id,
      selected: selected.includes(option.id)
    })
  }

  buildSelect(options) {
    const settings = merge({
      placeholderText: 'Seleccione',
      searchPlaceholder: 'Busca',
      searchingText: 'Buscando...',
      searchText: 'Sin resultados',
      allowDeselect: true,
    }, this.settingsValue)

    return new SlimSelect({
      settings,
      searchFilter: (option, search) =>
        option.text.match(new RegExp(search.replaceAll('%', '.*'), 'i')),
      ...options
    })
  }
}
